import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import * as React from 'react';
import { SmartRow } from '../../types';

interface Props {
  row: SmartRow;
  variant?: 'minimal';
}

export const Fightable: React.FC<Props> = (props) => {
  const { row, variant } = props;

  if (row.type === 'placeholder' || row.type === 'no-data') {
    return null;
  }

  const { fightable } = row;

  if (fightable) {
    return (
      <div
        className={`bg-green-50 text-green-900 rounded-full flex items-center justify-center space-x-1 px-2 py-1 h-8 ${
          variant === 'minimal' ? 'w-8' : ''
        }`}
      >
        <CheckIcon style={{ fontSize: 14 }} />
        {variant && variant === 'minimal' ? null : <span>can dispute</span>}
      </div>
    );
  }
  return (
    <div
      className={`bg-red-100 text-darkred-900 rounded-full flex items-center justify-center space-x-1 px-2 py-1 h-8 ${
        variant === 'minimal' ? 'w-8' : ''
      }`}
    >
      <ClearIcon style={{ fontSize: 14 }} />
      {variant && variant === 'minimal' ? null : <span>can&apos;t dispute</span>}
    </div>
  );
};
Fightable.displayName = 'SmartPerDiem.Table.Cell.Fightable';
